/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_Event_TemplatesInputs */



/**
* | output |
* | --- |
* | "Event Templates" |
*
* @param {Quicktools_Tab_Event_TemplatesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_event_templates = /** @type {((inputs?: Quicktools_Tab_Event_TemplatesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_Event_TemplatesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modeles d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisvorlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modelli di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Шаблоны мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plantillas de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテンプレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेम्प्लेट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelos de eventos")
	return /** @type {LocalizedString} */ ("Event Templates")
});